export default __webpack_public_path__ + "static/media/DefualtGroupPic.c471b7df.png";